module.exports = __webpack_public_path__ + "static/media/added-date-icon.23eb467a.svg";